import React from "react";

import {
  isValidIconName,
  useIsMobile,
  WSAvatar,
  WSCard,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSIconName,
  WSImage,
  WSText
} from "@wingspanhq/fe-component-library";
import { ISubscription } from "@wingspanhq/users";
import { useHistory } from "react-router-dom";
import { ExtendedWebflowBenefit } from "../types";
import { getCostOfBenefitWithSubscription } from "../utils";

interface BenefitsCMSBlockProps {
  benefit: ExtendedWebflowBenefit;
  subscription?: ISubscription;
  pagePath: string;
}

export const BenefitsCMSBlock: React.FC<BenefitsCMSBlockProps> = ({
  benefit,
  subscription,
  pagePath
}) => {
  const isMobile = useIsMobile();
  const history = useHistory();

  const {
    atAGlance,
    logo,
    icon: iconString,
    helperCostDescription,
    iconBackgroundColor = "blue50",
    iconColor = "blue500",
    name,
    slug
  } = benefit;

  let icon: WSIconName = "heart";
  if (!logo?.src && iconString) {
    if (isValidIconName(iconString)) {
      icon = iconString;
    }
  }

  return (
    <WSCard
      key={slug}
      data-testid={`block-${slug}`}
      onClick={() => history.push(pagePath, { comingFromBenefitsPage: true })}
      mt="L"
      p="L"
    >
      <WSFlexBox
        direction={isMobile ? "column" : "row"}
        justify="space-between"
        alignContent={isMobile ? "flex-start" : "center"}
        alignItems={isMobile ? "flex-start" : "center"}
        wrap="nowrap"
        gap="M"
      >
        <WSFlexBox.CenterY
          wrap="nowrap"
          style={{ flexBasis: "65%" }}
          pr="2XL"
          gap="XL"
        >
          {logo ? (
            <WSImage
              placeholder={
                <WSAvatar.Icon
                  icon={icon}
                  size="L"
                  color={iconColor}
                  colorBackground={iconBackgroundColor}
                />
              }
              src={logo.src}
              width={benefit.collectionId === "axis" ? 100 : 48}
            />
          ) : (
            <WSAvatar.Icon
              icon={icon}
              size="L"
              color={iconColor}
              colorBackground={iconBackgroundColor}
            />
          )}

          <WSElement>
            <WSText.Heading5>{name}</WSText.Heading5>
            <WSText.ParagraphXs color="gray500" mt="XS">
              {atAGlance}
            </WSText.ParagraphXs>
          </WSElement>
        </WSFlexBox.CenterY>

        {!benefit.hideCost && (
          <WSText.ParagraphSm style={{ flexBasis: "25%" }}>
            Cost: {getCostOfBenefitWithSubscription(benefit, subscription)}
          </WSText.ParagraphSm>
        )}

        {!isMobile && (
          <WSFlexBox style={{ flexBasis: "10%" }} justify="flex-end">
            <WSIcon block name="chevron-right" color="blue500" />
          </WSFlexBox>
        )}
      </WSFlexBox>
    </WSCard>
  );
};
